"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
* Version.ts
* @author Abhilash Panwar (abpanwar)
* @copyright Microsoft 2018
* File for SDK version.
*/
exports.Version = '1.8.6';
exports.FullVersionString = 'AWT-Web-JS-' + exports.Version;
